module.exports = __webpack_public_path__ + "img/adv_left_point.f5068aa1.png";